module.exports = __webpack_public_path__ + "img/img (38).905ccb66.png";